// src/plugins/rem.js
export default {
    install(Vue) {
        function setRem() {
            const designWidth = 1920
            const baseSize = 19
            const clientWidth = document.documentElement.clientWidth || document.body.clientWidth
            const scale = clientWidth / designWidth
            const fontSize = Math.min(Math.max(baseSize * scale, 14), 20)
            document.documentElement.style.fontSize = `${fontSize}px`
        }

        setRem()
        window.addEventListener('resize', setRem)
        window.addEventListener('orientationchange', setRem)
    }
}
